import classnames from 'classnames';

import useStyles from './styles';

const FeaturedInFallback = () => {
  const styles = useStyles();
  return (
    <div className={styles.root} data-testid="featured-in-with-logos-fallback">
      <i className={classnames('skeleton', styles.title)} />
      <ul className={styles.content}>
        <i className={classnames('skeleton', styles.item)} />
        <i className={classnames('skeleton', styles.item)} />
        <i className={classnames('skeleton', styles.item)} />
        <i className={classnames('skeleton', styles.item)} />
      </ul>
    </div>
  );
};

export default FeaturedInFallback;
